import styles from './AddCustomer.module.scss';
import { Modal } from "reactstrap";
import { Field, Form } from "react-final-form";
import { useEffect, useState } from 'react';
import arrayMutators from 'final-form-arrays'
import { AiOutlineClose as CloseIcon } from "react-icons/ai";
import { digitsOnly, onBlurFormatNumber, parseNumberForDB, removeSpace, setFieldTouchedMutator } from "../../../components/functions/utilities";
import OutlinedFormInput from '../../Finance/components/OutlinedFormInput/OutlinedFormInput';
import dayjs from 'dayjs';
import { countryCodeValidation, cutomEmailValidation, mobileNumberValidation, mobileNumberValidationDis, requiredCompanyWebsiteValidation } from '../../../components/functions/formValidation';
import { allowOnlyNumber, allowOnlyNumberPlus } from './NewUserModal';
import OutlinedInput from '../../../components/common/OutlinedInput/OutlineInput';
import MeritoSelectField from '../../Underwriting/components/selectfields/MeritoSelectField';
import { RestS } from '../../../rest/rest-service';
import MeritoButton from '../../../components/common/MeritoButtons/MeritoButtons';
import { triggerControlPanelRefresh } from '../../../redux/controlPanel/controlPanel';

type Props = {
  isOpen: boolean,
  closeForm: Function
}

const initialValues = {
  "companyName": "",
  "email": "",
  "companyWebsite": "",
  "name": "",
  "categoryId": 0,
  "phoneCode": "+91",
  "phoneNumber": "",
  "whatsappReport": 0
}

const AddCustomerModal = ({ isOpen, closeForm }: Props) => {
  useEffect(() => {
    console.log('isOpen', isOpen)
  }, [isOpen])
  const [brandCategoriesObj, setBrandCategoriesObj] = useState(null);
  const [apiErrors, setApiErrors] = useState(null);
  const [submitLoading, setSubmitLoading] = useState(false);

  useEffect(() => {
    RestS.fetchBrandCategoryOptions()
      .then(res => {
        const { categories } = res
        // console.log('categories',categories)
        if (categories.length) {
          const categoriesObj = categories.reduce((prev, curVal) => {
            prev[curVal.id] = curVal;
            return prev;
          }, {});

          type Category = {
            id: number;
            category: string;
          };

          // Convert object to array, sort by category, then convert back to object
          const sortedCategories: Record<number, Category> = Object.fromEntries(
            Object.entries(categories).sort(([, a], [, b]) => a.category.localeCompare(b.category))
          );

          console.log('categories', sortedCategories);
          setBrandCategoriesObj(sortedCategories);
        }
      })
  }, [])

  const handleSubmitForm = async (values) => {
    setSubmitLoading(true)
    console.log('Form submitted with values:', values);
    const formDetails = {
      "user": {
        companyName: values.companyName,
        email: values.email,
        companyWebsite: values.companyWebsite,
        name: `${values.firstName} ${values.lastName}`,
        categoryId: values.category?.id,
        phoneCode: values.phoneCode,
        phoneNumber: values.phoneNumber,
        whatsappReport: values.whatsappReport ? 1 : 0
      }
    }

    try {
      const res = await RestS.inviteBrand(formDetails);
      if (!res.success) {
        const errorsObject = res.err.reduce((acc, curr) => {
          acc[curr.field] = curr.message;
          return acc;
        }, {} as Record<string, string>);
        return errorsObject; // 🚨 This is the key step!
      }
      closeForm()
      triggerControlPanelRefresh()
    } catch (err) {
      return { _error: "Something went wrong." };
    } finally {
      setSubmitLoading(false)
    }
  };

  return (
    <Modal size="md" centered isOpen={isOpen} toggle={() => {
      closeForm();
    }}>
      <Form
        initialValues={initialValues}
        mutators={{
          ...arrayMutators,
          setFieldTouched: setFieldTouchedMutator
        }}
        validate={(values) => {
          const errors = {};
          if (values.phoneNumber && !values.phoneCode) {
            errors["phoneCode"] = "Required";
          }
          return errors;
        }}
        onSubmit={handleSubmitForm}
        render={({ values, handleSubmit, pristine, hasValidationErrors, form }) => {
          return (
            <div className={styles.formRootContainer}>
              <div>
                <div className={styles.headerContainer}>
                  <div className={styles.title}>
                    Invite Brand
                  </div>
                  <div className={styles.actionButtonContainer}>
                    <MeritoButton type="secondary-1" icon={<CloseIcon />} onlyIcon={true} onClick={(e) => {
                      e.stopPropagation();
                      closeForm();
                    }} />
                  </div>
                </div>

                <form onSubmit={handleSubmit}>
                  <div className={styles.formBodyContainer}>
                    <div className={styles.formBody}>
                      <div className={styles.sectionHeader}>
                        <h2>BRAND</h2>
                        <hr />
                      </div>
                      <div className={styles.fieldsContainer}>
                        <Field name="companyName" validate={value => !value && "Enter brand name"}>
                          {(props) => (
                            <OutlinedFormInput
                              {...props.input}
                              label="Name"
                              placeholder='Acme Brand'
                              name={props.input.name}
                              value={props.input.value}
                              onChange={props.input.onChange}
                              error={
                                props.meta.error && props.meta.touched
                                  ? props.meta.error
                                  : props.meta.submitError
                                    ? props.meta.submitError
                                    : null
                              }
                              touched={props.meta.touched}
                              maxLength={100}
                            />
                          )}
                        </Field>

                        <Field name="companyWebsite"
                          validate={(values) => {
                            if (!values) {
                              return 'Invalid website. Enter a valid URL'
                            }
                            requiredCompanyWebsiteValidation(values)
                          }}>
                          {(props) => (
                            <OutlinedFormInput
                              {...props.input}
                              placeholder='acmebrand.com'
                              label="Website"
                              name={props.input.name}
                              value={props.input.value}
                              onChange={props.input.onChange}
                              error={
                                props.meta.error && props.meta.touched
                                  ? props.meta.error
                                  : props.meta.submitError
                                    ? props.meta.submitError
                                    : null
                              }
                              touched={props.meta.touched}
                              maxLength={100}
                            />
                          )}
                        </Field>

                        <Field
                          name="category"
                          validate={(value) => {
                            if (!value) {
                              return `Select brand's product category`
                            }
                          }}
                        >
                          {(props) => (
                            <MeritoSelectField
                              {...props.input}
                              label="Category"
                              noOptionsMessage={'No results found'}
                              size="sm"
                              placeholder='Select Brand Category'
                              error={props.meta.error}
                              touched={props.meta.touched}
                              isClearable={false}
                              options={brandCategoriesObj ? Object.values(brandCategoriesObj) : []}
                              optionLabelKey='category'
                              value={props.input.value}
                              onChange={props.input.onChange}
                            />
                          )}
                        </Field>
                      </div>

                      <div className={`${styles.sectionHeader} ${styles.sectionHeader2}`}>
                        <h2>BRAND’S POINT OF CONTACT</h2>
                        <hr />
                      </div>
                      <p className={styles.subTitle}>Contact must be a brand team member like a founder, CXO, or marketer.</p>

                      <div className={styles.fieldsContainer}>
                        <div>
                          <p className={styles.label}>Name</p>
                          <div className={styles.hrFlex}>
                            <div style={{ width: '50%' }}>
                              <Field name="firstName" validate={value => !value && "Enter user’s first name"}>
                                {(props) => (
                                  <OutlinedFormInput
                                    {...props.input}
                                    label=""
                                    placeholder='John'
                                    name={props.input.name}
                                    value={props.input.value}
                                    onChange={props.input.onChange}
                                    error={props.meta.error}
                                    touched={props.meta.touched}
                                  />
                                )}
                              </Field>
                            </div>
                            <div style={{ width: '50%' }}>
                              <Field name="lastName" validate={value => !value && "Enter user’s last name"}>
                                {(props) => (
                                  <OutlinedFormInput
                                    {...props.input}
                                    label=""
                                    placeholder='Doe'
                                    name={props.input.name}
                                    value={props.input.value}
                                    onChange={props.input.onChange}
                                    error={props.meta.error}
                                    touched={props.meta.touched}
                                  />
                                )}
                              </Field>
                            </div>
                          </div>

                        </div>

                        <Field name="email" validate={(value) => {
                          if (!value) {
                            return 'Enter user’s email'
                          }
                          cutomEmailValidation(value)
                        }}>
                          {(props) => {
                            return (
                              <OutlinedFormInput
                                {...props.input}
                                error={
                                  props.meta.error && props.meta.touched
                                    ? props.meta.error
                                    : props.meta.submitError
                                      ? props.meta.submitError
                                      : null
                                }
                                label="Email"
                                value={props.input.value}
                                onChange={(e) => { props.input.onChange(e); console.log('changed value', props.input.value) }}
                                placeholder="john@mail.com"
                                touched={props.meta.touched}
                              />
                            );
                          }}
                        </Field>

                        <div>
                          <div className={styles.phoneField}>
                            <div className={styles.whatsappIcon}>
                              <img src={'https://assets.clickmerito.com/images/whatsapp.svg'}></img>
                            </div>
                            <div style={{ width: "15%" }}>
                              <Field
                                name="phoneCode"
                                defaultValue="+91"
                                validate={(values) => {
                                  if (values) {
                                    return countryCodeValidation(values);
                                  } else return "";
                                }}
                              >
                                {(props) => {
                                  return (
                                    <OutlinedFormInput
                                      {...props.input}
                                      maxLength={4}
                                      error={
                                        props.meta.error && props.meta.touched
                                          ? props.meta.error
                                          : props.meta.submitError
                                            ? props.meta.submitError
                                            : null
                                      }
                                      value={props.input.value}
                                      onChange={(e) => {
                                        const sanitizedValue = removeSpace(e.target.value);
                                        const validate = allowOnlyNumberPlus(
                                          sanitizedValue,
                                        );

                                        if (validate) {
                                          // To handle case where they try to
                                          // enter a four digit number
                                          if (
                                            sanitizedValue &&
                                            sanitizedValue[0] !== "+" &&
                                            sanitizedValue.length > 3
                                          ) {
                                            return;
                                          }

                                          props.input.onChange(sanitizedValue);
                                        }
                                      }}
                                      onBlur={() => {
                                        // to handle case where they enter nothing and blur
                                        if (!props.input.value)
                                          props.input.onChange(`+91`);
                                        // To handle case where they only enter number and blur
                                        else if (props.input.value[0] !== "+")
                                          props.input.onChange(
                                            `+${props.input.value.slice(0, 3)}`,
                                          );
                                        // To handle case where they enter only + and then blur
                                        else if (props.input.value[0] === "+" && props.input.value.length == 1)
                                          props.input.onChange(`+91`);
                                      }}
                                      placeholder="+91"
                                      touched={true}
                                    />
                                  );
                                }}
                              </Field>
                            </div>
                            <div style={{ flexGrow: "1" }}>
                              <Field
                                name="phoneNumber"
                                validate={(values) => {
                                  if (values) {
                                    return mobileNumberValidation(values);
                                  } else return "";
                                }}
                              >
                                {(props) => {
                                  return (
                                    <OutlinedFormInput
                                      {...props.input}
                                      maxLength={11}
                                      error={
                                        props.meta.error && props.meta.touched
                                          ? props.meta.error
                                          : props.meta.submitError
                                            ? props.meta.submitError
                                            : null
                                      }
                                      value={props.input.value}
                                      onChange={(e) => {
                                        const sanitizedValue = digitsOnly(e.target.value);

                                        allowOnlyNumber(sanitizedValue)
                                          ? props.input.onChange(sanitizedValue)
                                          : {}
                                        if (!mobileNumberValidationDis(sanitizedValue)) {
                                          form.change(
                                            'whatsappReport',
                                            0
                                          )
                                        }
                                      }
                                      }
                                      placeholder="9876543210"
                                      touched={true}
                                    />
                                  );
                                }}
                              </Field>
                            </div>
                          </div>

                          <Field name="whatsappReport" type="checkbox">
                            {(props) => {
                              console.log('values.phoneNumber', values.phoneNumber)
                              return (
                                <div className={styles.whatsAppReport}>
                                  <input
                                    type="checkbox"
                                    {...props.input}
                                    disabled={!mobileNumberValidationDis(values.phoneNumber)}
                                    value={props.input.value}
                                    onChange={props.input.onChange}
                                    className={`${!mobileNumberValidationDis(values.phoneNumber) ? styles.disabled : ''}`}
                                  />
                                  <div className={styles.whatsAppReportText}>
                                    Send WhatsApp reports to brand
                                  </div>
                                </div>
                              );
                            }}
                          </Field>
                        </div>

                      </div>

                    </div>
                  </div>
                </form>
              </div>
              <div className={styles.footer}>
                <MeritoButton
                  type="tertiary"
                  size="md"
                  onClick={() => { closeForm() }}
                  btnText="Cancel"
                />
                <MeritoButton
                  type="primary-1"
                  size="md"
                  btnText="Send Invite"
                  onClick={() => {
                    form.submit()
                  }}
                  loading={submitLoading}
                // disabled={updateDisable}
                />
              </div>
            </div>
          )
        }}
      />
    </Modal >
  )
}

export default AddCustomerModal;